module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content sites-list-setting"
  }, [_c('setting-title', {
    attrs: {
      "title": "站点管理",
      "description": "只有在本列表中的站点才会被统计。请准确添加站点和统计代码"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.domainList.length > 0),
      expression: "domainList.length > 0"
    }],
    staticClass: "btn btn-primary pull-right add-site btn-big",
    on: {
      "click": _vm.openSiteNew
    }
  }, [_vm._v("添加新站点")])]), _c('div', {
    directives: [{
      name: "flowgrid",
      rawName: "v-flowgrid",
      value: (4),
      expression: "4"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.domainList.length > 0),
      expression: "domainList.length > 0"
    }],
    staticClass: "sites-list"
  }, _vm._l((_vm.domainList), function(item, $index) {
    return _c('li', [_c('div', {
      staticClass: "site-item"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.goToReport(item.id)
        }
      }
    }, [_c('h2', {
      attrs: {
        "title": item.domainTitle || item.domain
      }
    }, [_vm._v(_vm._s(item.domainTitle || item.domain))])]), _c('span', {
      staticClass: "opt"
    }, [_c('a', {
      attrs: {
        "title": "获取代码"
      },
      on: {
        "click": function($event) {
          _vm.openCodePopup(item)
        }
      }
    }, [_vm._v("获取代码")]), _c('a', {
      staticClass: "edit",
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          _vm.openSiteEdit(item, $index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit fa-lg"
    })]), _c('a', {
      staticClass: "delete",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          _vm.openDeleteSite(item, $index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o fa-lg"
    })])])]), _c('div', {
      staticClass: "desc"
    }, [_c('h3', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.industry_1 && item.industry_2),
        expression: "item.industry_1 && item.industry_2"
      }]
    }, [_vm._v(_vm._s(item.industryText))]), _c('p', [_vm._v("生效时间：" + _vm._s(item.effecttime))])]), (item.subDomain.length > 0) ? _c('dl', [_c('dt', [_vm._v("其他域名 (共" + _vm._s(item.subDomain.length) + "个)")]), _vm._l((item.subDomain), function(sub, index) {
      return _c('dd', [_c('span', {
        staticClass: "index"
      }, [_vm._v(_vm._s(index + 1) + "." + _vm._s(sub))])])
    })], 2) : _vm._e()])])
  })), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.domainList.length === 0),
      expression: "domainList.length === 0"
    }],
    staticClass: "zone content-part iframe-header"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-bolt",
      "title": "新建站点"
    },
    slot: "icon"
  }), _c('div', {
    staticClass: "header-chart-line"
  }), _c('v-form', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite),
      expression: "activeSite"
    }],
    ref: "newSite",
    attrs: {
      "before-submit": _vm.preventSubmit
    },
    domProps: {
      "value": (_vm.activeSite)
    },
    on: {
      "input": function($event) {
        _vm.activeSite = $event
      }
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "站点名称"
    }
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite.domainTitle),
      expression: "activeSite.domainTitle"
    }],
    attrs: {
      "rules": _vm.rules.title,
      "placeholder": "请输入1-50字符名称"
    },
    domProps: {
      "value": (_vm.activeSite.domainTitle)
    },
    on: {
      "input": function($event) {
        _vm.activeSite.domainTitle = $event
      }
    }
  })], 1), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("站点分类：")]), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite.industry_1),
      expression: "activeSite.industry_1"
    }],
    staticClass: "industry",
    class: {
      error: _vm.industrySelectionsDirty && _vm.industryErrors[0]
    },
    on: {
      "change": [function($event) {
        _vm.activeSite.industry_1 = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.resetSubIndustry]
    }
  }, _vm._l((_vm.industryMainList), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite.industry_2),
      expression: "activeSite.industry_2"
    }],
    staticClass: "sub-industry",
    class: {
      error: _vm.industrySelectionsDirty && _vm.industryErrors[1]
    },
    on: {
      "change": [function($event) {
        _vm.activeSite.industry_2 = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, function($event) {
        _vm.industrySelectionsDirty = true
      }]
    }
  }, _vm._l((_vm.industrySubList), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.industrySelectionsDirty && (_vm.industryErrors[0] || _vm.industryErrors[1])),
      expression: "industrySelectionsDirty && (industryErrors[0] || industryErrors[1])"
    }],
    staticClass: "error"
  }, [_vm._v("请选择分类")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("主域名：")]), _c('div', {
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite.domain),
      expression: "activeSite.domain"
    }],
    attrs: {
      "rules": _vm.rules.domain,
      "placeholder": "请输入域名如 aaa.com, 300 字符以内"
    },
    domProps: {
      "value": (_vm.activeSite.domain)
    },
    on: {
      "input": [function($event) {
        _vm.activeSite.domain = $event
      }, _vm.onDomainInput]
    }
  })], 1)]), _vm._l((_vm.activeSite.subDomain), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("域名 " + _vm._s(index + 1) + "：")]), _c('div', {
      staticClass: "control"
    }, [_c('v-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.activeSite.subDomain[index]),
        expression: "activeSite.subDomain[index]"
      }],
      ref: "subdomain",
      refInFor: true,
      attrs: {
        "rules": _vm.rules.subDomain,
        "placeholder": "请输入域名，不建议输入带path的URL"
      },
      domProps: {
        "value": (_vm.activeSite.subDomain[index])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.activeSite.subDomain,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.activeSite.subDomain[index] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }), _c('a', {
      on: {
        "click": function($event) {
          _vm.removeSubDomain(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)])
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSite.subDomain.length > 0),
      expression: "activeSite.subDomain.length > 0"
    }],
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "note-text"
  }, [_vm._v("（注：添加其他域名需与主域名不同，实现跨域监测数据）")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSite.subDomain.length < 6),
      expression: "activeSite.subDomain.length < 6"
    }],
    staticClass: "btn btn-primary btn-icon btn-big",
    staticStyle: {
      "padding": "0"
    },
    on: {
      "click": _vm.addSubDomain
    }
  }, [_vm._v("添加其他域名")])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _c('button', {
    staticClass: "btn btn-primary btn-small",
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("保存")])])], 2)], 1), _c('v-modal', {
    ref: "formModal",
    attrs: {
      "visible": _vm.siteInfoVisible,
      "title": _vm.siteInfoTitle
    },
    on: {
      "closemodal": _vm.hideSiteInfo
    }
  }, [(_vm.siteInfoVisible) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('v-form', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite),
      expression: "activeSite"
    }],
    attrs: {
      "before-submit": _vm.preventSubmit
    },
    domProps: {
      "value": (_vm.activeSite)
    },
    on: {
      "input": function($event) {
        _vm.activeSite = $event
      }
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "站点名称"
    }
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite.domainTitle),
      expression: "activeSite.domainTitle"
    }],
    attrs: {
      "rules": _vm.rules.title,
      "placeholder": "请输入1-50字符名称"
    },
    domProps: {
      "value": (_vm.activeSite.domainTitle)
    },
    on: {
      "input": function($event) {
        _vm.activeSite.domainTitle = $event
      }
    }
  })], 1), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("站点分类：")]), _c('div', {
    staticClass: "control"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite.industry_1),
      expression: "activeSite.industry_1"
    }],
    staticClass: "industry",
    class: {
      error: _vm.industrySelectionsDirty && _vm.industryErrors[0]
    },
    on: {
      "change": [function($event) {
        _vm.activeSite.industry_1 = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, _vm.resetSubIndustry]
    }
  }, _vm._l((_vm.industryMainList), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite.industry_2),
      expression: "activeSite.industry_2"
    }],
    staticClass: "sub-industry",
    class: {
      error: _vm.industrySelectionsDirty && _vm.industryErrors[1]
    },
    on: {
      "change": [function($event) {
        _vm.activeSite.industry_2 = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }, function($event) {
        _vm.industrySelectionsDirty = true
      }]
    }
  }, _vm._l((_vm.industrySubList), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.industrySelectionsDirty && (_vm.industryErrors[0] || _vm.industryErrors[1])),
      expression: "industrySelectionsDirty && (industryErrors[0] || industryErrors[1])"
    }],
    staticClass: "error"
  }, [_vm._v("请选择分类")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("主域名：")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteInfoStatus === 'edit'),
      expression: "siteInfoStatus === 'edit'"
    }],
    staticClass: "control",
    staticStyle: {
      "float": "left",
      "max-width": "400px",
      "word-break": "break-word",
      "margin-top": "8px",
      "line-height": "2"
    }
  }, [_vm._v(_vm._s(_vm.activeSite.domain)), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite.domain),
      expression: "activeSite.domain"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm._s(_vm.activeSite.domain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activeSite.domain = $event.target.value
      }
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.siteInfoStatus === 'new'),
      expression: "siteInfoStatus === 'new'"
    }],
    staticClass: "control"
  }, [_c('v-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSite.domain),
      expression: "activeSite.domain"
    }],
    attrs: {
      "rules": _vm.rules.domain,
      "placeholder": "请输入域名如aaa.com,300字符以内"
    },
    domProps: {
      "value": (_vm.activeSite.domain)
    },
    on: {
      "input": [function($event) {
        _vm.activeSite.domain = $event
      }, _vm.onDomainInput]
    }
  })], 1)]), _vm._l((_vm.activeSite.subDomain), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "label"
    }, [_vm._v("域名 " + _vm._s(index + 1) + "：")]), _c('div', {
      staticClass: "control"
    }, [_c('v-input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.activeSite.subDomain[index]),
        expression: "activeSite.subDomain[index]"
      }],
      ref: "subdomain",
      refInFor: true,
      attrs: {
        "rules": _vm.rules.subDomain,
        "placeholder": "请输入域名，不建议输入带path的URL"
      },
      domProps: {
        "value": (_vm.activeSite.subDomain[index])
      },
      on: {
        "input": function($event) {
          var $$exp = _vm.activeSite.subDomain,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.activeSite.subDomain[index] = $event
          } else {
            $$exp.splice($$idx, 1, $event)
          }
        }
      }
    }), _c('a', {
      on: {
        "click": function($event) {
          _vm.removeSubDomain(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)])
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSite.subDomain.length > 0),
      expression: "activeSite.subDomain.length > 0"
    }],
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "note-text"
  }, [_vm._v("（注：添加其他域名需与主域名不同，实现跨域监测数据）")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSite.subDomain.length < 6),
      expression: "activeSite.subDomain.length < 6"
    }],
    staticClass: "btn btn-primary btn-icon btn-big",
    staticStyle: {
      "padding": "0"
    },
    on: {
      "click": _vm.addSubDomain
    }
  }, [_vm._v("添加其他域名")])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _c('button', {
    staticClass: "btn btn-primary btn-small",
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("保存")]), _c('div', {
    staticClass: "btn btn-default btn-small",
    on: {
      "click": _vm.hideSiteInfo
    }
  }, [_vm._v("取消")])])], 2)], 1) : _vm._e()]), _c('v-modal', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": "获取代码"
    },
    on: {
      "closemodal": function($event) {
        _vm.dialogVisible = false;
        _vm.noCopy = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-bd"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('p', [_vm._v("请将框内代码复制到您网站所有页面的</body>前，添加成功后立即开始统计。")]), _c('textarea', {
    staticClass: "code-area",
    attrs: {
      "cols": "80",
      "rows": "6",
      "id": "jsCodeArea"
    }
  }, [_vm._v(_vm._s(_vm.currentJscode || '正在获取中...'))]), _c('p', {
    staticClass: "clip-note"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.copySuccess),
      expression: "copySuccess"
    }]
  }, [_vm._v("复制成功，复制内容已经进入您的剪切板，右键“粘贴”即可。")])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.noCopy),
      expression: "!noCopy"
    }],
    staticClass: "btn-wrap"
  }, [_c('button', {
    ref: "jsCopyCode",
    staticClass: "btn btn-primary btn-medium",
    attrs: {
      "data-clipboard-action": "copy",
      "data-clipboard-target": "#jsCodeArea"
    }
  }, [_vm._v("复制代码")])])])]), _c('v-modal', {
    attrs: {
      "visible": _vm.deletePopShown,
      "title": "确定删除该域名吗？"
    },
    on: {
      "closemodal": function($event) {
        _vm.deletePopShown = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._v("删除后，站点所有历史数据将被清空，且无法恢复。确定删除后，请同时移除您网站上的360统计代码。")]), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-small",
    on: {
      "click": _vm.deleteSite
    }
  }, [_vm._v("确定")]), _c('button', {
    staticClass: "btn btn-default btn-small",
    on: {
      "click": function($event) {
        _vm.deletePopShown = false
      }
    }
  }, [_vm._v("取消")])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e94bd5c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e94bd5c4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/setting/sites.vue
// module id = 808
// module chunks = 0